exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";.breadcrumb[data-v-15bd527a]{background:none;font-size:10px;padding:0;margin:0}.breadcrumb-item+.breadcrumb-item[data-v-15bd527a]:before{content:\"\\276F\";font-size:6px;color:#8991ae;transform:translate(1px,-1px)}.breadcrumb-item.active[data-v-15bd527a]{color:#8991ae}", ""]);

// exports
